import OrgnzList from '@/views/orgStatus/OrgnzList'
import OrgnzSearch from '@/views/orgStatus/OrgnzSearch'
import OrgnzDetail from '@/views/orgStatus/OrgnzDetail'
import OrgnzProfile from '@/views/orgStatus/OrgnzDetailProfile'
import OrgnzMemo from '@/views/orgStatus/OrgnzDetailMemo'

export default [
    {
        path: '/orgStatus/orgStatusList',
        name: 'orgnz-list',
        component: OrgnzList,
        meta: { auth: true,
            logging: true,
            pageName: '조직현황 목록' }
    },
    {
        path: '/orgStatus/orgStatusList/detailedSearch',
        name: 'orgnz-search',
        component: OrgnzSearch,
        meta: { auth: true,
            logging: true,
            pageName: '조직현황 상세검색' }
    },
    {
        path: '/orgStatus/orgStatusView',
        name: 'orgnz-detail',
        component: OrgnzDetail,
        meta: { auth: true,
            logging: true,
            pageName: '조직현황 상세' }
    },
    {
        path: '/orgStatus/orgStatusView/profileDetails',
        name: 'orgnz-profile',
        component: OrgnzProfile,
        meta: { auth: true,
            logging: true,
            pageName: '조직현황 프로필 상세' }
    },
    {
        path: '/orgStatus/orgStatusView/memo',
        name: 'orgnz-memo',
        component: OrgnzMemo,
        meta: { auth: true,
            logging: true,
            pageName: '조직현황 메모' }
    },


]